import { hash } from '@ember/helper';
import Component from '@glimmer/component';

import type { WithBoundArgs } from '@glint/template';
import BasicDropdown from 'ember-basic-dropdown/components/basic-dropdown';
import type { HorizontalPosition } from 'ember-basic-dropdown/types';

import Button from 'umg-ember-backend/components/ui/button';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import Item from './item';
import styles from './styles.module.css';

const bem = getBem(styles);

type ContextMenuItem = WithBoundArgs<typeof Item, 'dropdown'>;

interface ContextMenuSignature {
  Args: {
    horizontalPosition?: HorizontalPosition;
    isDisabled?: boolean;
    renderInPlace?: boolean;
    stopPropagation?: boolean;
  };
  Blocks: {
    default: [content: { item: ContextMenuItem }];
    trigger: [];
    content: [content: { Item: ContextMenuItem }];
  };
  Element: HTMLElement;
}

export default class UiContextMenuComponent extends Component<ContextMenuSignature> {
  // Getter and setter
  get renderInPlace() {
    return this.args.renderInPlace ?? true;
  }

  // Template
  <template>
    <BasicDropdown
      @disabled={{@isDisabled}}
      @renderInPlace={{this.renderInPlace}}
      @horizontalPosition={{@horizontalPosition}}
      class={{(bem)}}
      ...attributes
      as |dropdown|
    >
      <dropdown.Trigger
        @stopPropagation={{@stopPropagation}}
        class={{bem 'trigger'}}
      >
        {{#if (has-block 'trigger')}}
          {{yield to='trigger'}}
        {{else}}
          <Button
            @icon='more'
            @style='inline'
            tabindex='-1'
            disabled={{@isDisabled}}
          />
        {{/if}}
      </dropdown.Trigger>
      <dropdown.Content class={{bem 'content'}}>
        {{#if (has-block 'content')}}
          {{yield (hash Item=(component Item dropdown=dropdown)) to='content'}}
        {{else}}
          {{yield (hash item=(component Item dropdown=dropdown))}}
        {{/if}}
      </dropdown.Content>
    </BasicDropdown>
  </template>
}
